<template>
    <validation-observer ref="form" v-slot="{ handleSubmit, meta, setFieldValue, errors }">
        <modal
            :id="modalId"
            title="Upload file"
            ok-title="Upload"
            :ok-disabled="!meta.valid"
            @ok.prevent="handleSubmit(_, save)"
        >
            <busy-modal :show="busy"></busy-modal>
            <b-form @submit.prevent="handleSubmit(_, save)">
                <b-row>
                    <b-col>
                        <validation-provider name="description" rules="required">
                            <form-input
                                label="Description:"
                                v-model="values.description"
                                :error="errors.description"
                                @input="(val) => setFieldValue('description', val)"
                            >
                            </form-input>
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <form-select
                            label="Property:"
                            v-model="values.rental_property"
                            :options="propertiesOptions"
                        ></form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <form-select label="Category:" v-model="values.category" :options="areasOptions"></form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <validation-provider name="user_file" rules="required">
                            <form-file
                                label="File:"
                                class="overflow-hidden"
                                placeholder="Upload new file"
                                v-model="values.user_file"
                                :left-icon="['fas', 'file']"
                                :error="errors.user_file"
                                @input="(val) => setFieldValue('user_file', val)"
                            ></form-file>
                        </validation-provider>
                    </b-col>
                </b-row>
            </b-form>
        </modal>
    </validation-observer>
</template>

<script>
    import isEmpty from 'lodash/isEmpty';
    import BusyModal from '../../generic/busy-modal/busy-modal.vue';
    import Modal from '../../generic/modal/modal.vue';
    import FormInput from '../../generic/form-input/form-input.vue';
    import FormSelect from '../../generic/form-select/form-select.vue';
    import FormFile from '../../generic/form-file/form-file.vue';
    import { formatResponseError } from '../../../utils/api';

    export default {
        name: 'DocumentUploadModalForm',
        components: {
            Modal,
            FormInput,
            FormSelect,
            FormFile,
            BusyModal,
        },
        props: {
            modalId: String,
            create: {
                type: Function,
                default: () => Promise.resolve(),
            },
            areasOptions: {
                type: Array,
                default: () => [],
            },
            propertiesOptions: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                busy: false,
                values: {
                    description: null,
                    user_file: null,
                    rental_property: null,
                    category: null,
                },
            };
        },
        methods: {
            hideModal() {
                this.$bvModal.hide(this.modalId);
            },
            async save() {
                try {
                    this.busy = true;
                    const data = new FormData();
                    Object.entries(this.values).forEach(([key, value]) => {
                        if (value) {
                            data.append(key, value);
                        }
                    });
                    await this.create(data);
                    this.$emit('success-save');
                    this.$nextTick(() => {
                        this.hideModal();
                    });
                } catch (err) {
                    const { generic, fields } = formatResponseError(err);

                    if (generic) {
                        this.errorToast({ text: generic });
                    }
                    if (!isEmpty(fields)) {
                        this.$refs.form.setErrors(fields);
                    }
                } finally {
                    this.busy = false;
                }
            },
        },
    };
</script>
